import { CompleteNode } from "../../../../../libs/ts/WorkflowTree/Nodes/CompleteNode";
import { IWorkflowFactory } from "../factories/IWorkflowFactory";
import { Model } from "../Model";
import { JbpTreeNodeData } from "../treeExtensions/JbpTreeNodeData";
import { FieldType, ITextField } from "../treeExtensions/FieldInterfaces";
import { IJbpChildNodeRelationship } from "../treeExtensions/IJbpChildNodeRelationship";
import { useIsInternalUser } from "../hooks/useUserPermissions";
import { ValidationResponse } from "../components/ValidationResponse";

export class JobCommentsNode extends CompleteNode<JbpTreeNodeData, IJbpChildNodeRelationship> {

    public static GetPrependedData() {
        const prependedFieldPaths = [
            "model.jobCommentPrependedMessages.liftOnSite",
            "model.jobCommentPrependedMessages.accessInstructions",
            "model.jobCommentPrependedMessages.whatThreeWordsReference",
            "model.jobCommentPrependedMessages.parkingInfo",
            "model.jobCommentPrependedMessages.customerAgreesToPowerDown",
            "model.jobCommentPrependedMessages.siteInductionNotRequired",
            "model.jobCommentPrependedMessages.extraSkills"
        ]

        const prependedData = prependedFieldPaths.map((path) => {
            const value = Model.GetModel().Get(path);
            return value == undefined ? "" : value
        }).join('');

        return prependedData;
    }

    public static GetJobComments() {
        const prependedData = JobCommentsNode.GetPrependedData();
        const comments = Model.GetModel().Get("model.results.jobComments");
        return prependedData + comments;
    }

    constructor(mpan: string, serviceLine: string) {

        const determineOffersPath = () => {
            if(useIsInternalUser()) {
                return `/bookJob/internalOffers/${mpan}/${serviceLine}`;
            }
            return `/bookJob/offers/${mpan}/${serviceLine}`;
        }

        const relationship = {
            workflowButtonText: "Get Job Dates",
            relationshipModelPath: IWorkflowFactory.sequenceRelationship.relationshipModelPath,
            modelValueWhenRelationshipIsTrue: IWorkflowFactory.sequenceRelationship.modelValueWhenRelationshipIsTrue,
            determinePathOnSelect: determineOffersPath
        } as IJbpChildNodeRelationship

        const commentsField = {
            fieldType: FieldType.TextArea,
            title: "Additional Comments",
            placeHolder: "Advise of any parking or access instructions/ restrictions, site directions, meter location information, health & safety concerns (e.g. face mask), and any other access information",
            modelPath: "model.results.jobComments",
            mandatory: true,
            isValid: (value: string): ValidationResponse => {
                if(value != undefined && value.length > 0) {
                    return {
                        isValid: true
                    }
                }
                return {
                    isValid: false,
                    errorMessage: "Please enter additional comments to proceed"
                }
            },
            getDynamicFieldConstraints: () => {
                const prependedData = JobCommentsNode.GetPrependedData();
                const jobCommentsStandardLength = 2000;

                return {
                    maxLength: jobCommentsStandardLength - prependedData.length
                }
            }
        } as ITextField;

        super("jobComments", new JbpTreeNodeData("Please enter any further information or instructions relating to this job", [commentsField]), relationship);
    }
}
